import React from 'react';
import { InputAdornment, TextField } from '@mui/material';
import FilterList from '@mui/icons-material/FilterList';

interface ColumnFilterProps {
  columnName: string;
  onChange: (singleColFilter: { [key: string]: string }) => void;
  value: string;
}

// columns that don't filter with a simple string CONTAINS
export const columnTypesMap: { [key: string]: string } = {
  createDate: 'date',
  revenue: 'number',
};

export const ColumnFilter = ({ columnName, onChange, value }: ColumnFilterProps) => {
  return (
    <TextField
      variant='outlined'
      type={columnName in columnTypesMap ? columnTypesMap[columnName] : 'search'}
      size='small'
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <FilterList fontSize='small' />
          </InputAdornment>
        ),
      }}
      onChange={e => {
        onChange({ [columnName]: e.target.value });
      }}
      value={value}
    />
  );
};
